// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import React from "react";
// import * as firebase from "firebase";
import { auth } from "./firebase";
// import Axios from "axios";
// import firebase from "firebase/compat/app";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signOut,
  signInWithEmailAndPassword,
} from "firebase/auth";

const withAuthProvider = (WrappedComponent) => {
  class authComponent extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        componentLoading: true,
        error: null,
        isAuthenticated: false,
        isAdmin: false,
        user: { loading: true },
        isEmployer: "",
        key: "",
        isLoading: true,
      };
    }

    getUserRole = async () => {
      // this.setState({
      //   isLoading: true,
      // });
      if (auth.currentUser) {
        auth.currentUser
          .getIdTokenResult()
          .then((idTokenResult) => {
            const signedinUser = auth.currentUser;

            signedinUser.roles = idTokenResult.claims.roles;
            this.setState({
              isAdmin: idTokenResult.claims.admin,
              // user: signedinUser,
              // key: signedinUser.email,
              isEmployer:
                idTokenResult.claims.roles &&
                idTokenResult.claims.roles.includes("employer"),
              // isLoading: false,
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
      // this.setState({
      //   isLoading: false,
      // });
    };
    authenticatedUser = () => {
      // Axios.post(apiRoutes[environment].auth).then((resp) => {
      //   this.setState({
      //     user: resp.data,
      //     isAuthenticated: resp.data.isAuthenticated,
      //   });
      //   console.log(resp.data);
      //   return resp.data;
      // });
    };

    async componentDidMount() {
      var that = this;
      auth.onAuthStateChanged(async function (user) {
        if (user) {
          // that.setState({
          //   isLoading: false,
          //   user: user.currentUser,
          //   key: user.email,
          // });
          const idTokenResult = await user.getIdTokenResult();
          var signedinUser = user;
          signedinUser.roles = idTokenResult.claims.roles;
          that.setState({
            isAdmin: idTokenResult.claims.admin,
            user: signedinUser,
            key: user.email,
            isEmployer:
              idTokenResult.claims.roles &&
              idTokenResult.claims.roles.includes("employer"),
            isLoading: false,
            isAuthenticated: true,
          });
          user.getIdToken(true);
          that.getUserRole();
        } else {
          that.setState({ user: null, isLoading: false });
        }
      });
    }

    async login() {
      // history.push("/sso/login");
      window.location = "/sso/login";
    }
    async logout() {
      // history.push("/sso/login");
      window.location = "/sso/logout";
    }
    render() {
      return (
        <WrappedComponent
          error={this.state.error}
          isLoading={this.state.isLoading}
          isAuthenticated={this.state.isAuthenticated}
          user={this.state.user}
          isAdmin={this.state.isAdmin}
          isEmployer={this.state.isEmployer}
          key={this.state.key}
          login={() => this.login()}
          logout={() => this.logout()}
          getAccessToken={(scopes) => this.getAccessToken(scopes)}
          setError={(message, debug) => this.setErrorMessage(message, debug)}
          {...this.props}
        />
      );
    }
  }

  return authComponent;
};

export default withAuthProvider;
